if (!customElements.get('gz-tab-content')) {
  class GzTabContent extends HTMLElement {
    constructor() {
      super();
      this.buttons = [];
      this.contents = [];
    }

    connectedCallback() {
      this.buttons = Array.from(this.querySelectorAll("[data-tab-btn]"));
      this.contents = Array.from(this.querySelectorAll("[data-tab-content]"));

      // Bind events
      this.buttons.forEach(btn => {
        btn.addEventListener("click", () => this.openTab(btn.dataset.tabBtn));
      });

      // Check if there's already an active button, if so open that tab
      const activeBtn = this.querySelector("[data-tab-btn].active");
      
      if (activeBtn) {
        this.openTab(activeBtn.dataset.tabBtn);
      } else if (this.buttons.length) {
        // Fallback to first tab if none are active
        this.openTab(this.buttons[0].dataset.tabBtn);
      }
    }

    openTab(id) {
      // Update buttons
      this.buttons.forEach(btn => {
        const isActive = btn.dataset.tabBtn === id;
        btn.classList.toggle("active", isActive);
      });

      // Update tab content with inline style
      this.contents.forEach(content => {
        const match = content.dataset.tabContent === id;
        content.classList.toggle("active", match);
        content.style.display = match ? "" : "none";
      });
    }
  }
  customElements.define("gz-tab-content", GzTabContent);
}